import { OTA_VehAvailRateRQ } from "./ota_vehavailraterq.model";
import { OTA_VehResRQ } from "./ota_vehresrq.model";
import { OTA_VehRetResRQ } from "./ota_vehretresrq.model";
import { OTA_VehCancelRQ } from "./ota_vehcancelrq.model";
import { OTA_VehModifyRQ } from "./ota_vehmodifyrq.model";

export enum enumRequestType {
    reqType_Unknown = 0,
    reqType_VehAvailRate = 1,
    reqType_VehRes = 2,
    reqType_VehModify = 3,
    reqType_VehCancel = 4,
    reqType_Profile = 5,
    reqType_ProfileCreate = 6,
    reqType_ProfileModify = 7,
    reqType_VehRetRes = 8
}

export class OTA_Request {
    public requestType: enumRequestType;
    public otA_VehAvailRateRQ: OTA_VehAvailRateRQ;
    public otA_VehResRQ: OTA_VehResRQ;
    public otA_VehModifyRQ: OTA_VehModifyRQ;
    public otA_VehCancelRQ: OTA_VehCancelRQ;
    public otA_VehRetResRQ: OTA_VehRetResRQ;

    public constructor(reqType: enumRequestType) {
        this.requestType = reqType;

        switch (reqType) {
            case enumRequestType.reqType_VehAvailRate:
                this.otA_VehAvailRateRQ = new OTA_VehAvailRateRQ();
                break;

            case enumRequestType.reqType_VehRes:
                this.otA_VehResRQ = new OTA_VehResRQ();
                break;

            case enumRequestType.reqType_VehModify:
                this.otA_VehModifyRQ = new OTA_VehModifyRQ();
                break;

            case enumRequestType.reqType_VehCancel:
                this.otA_VehCancelRQ = new OTA_VehCancelRQ();
                break;

            //case enumRequestType.reqType_Profile:
            //case enumRequestType.reqType_ProfileCreate:
            //case enumRequestType.reqType_ProfileModify:

            case enumRequestType.reqType_VehRetRes:
                this.otA_VehRetResRQ = new OTA_VehRetResRQ();
                break;
        }
    }
}